module.exports = __webpack_public_path__ + "img/zsk (6).90cd5e4f.jpg";